import { useState } from "react";
import type { Document, SaveFn } from "../../../lib/profileTypes";
import { DOC_TYPES } from "../../../lib/profileTypes";
import { SectionCard } from "../card/SectionCard";

interface DocumentsTabProps {
  documents: Document[];
  canWrite: boolean;
  onSave: SaveFn;
  saving: boolean;
}

export function DocumentsTab({
  documents,
  canWrite,
  onSave,
  saving,
}: DocumentsTabProps) {
  const [docs, setDocs] = useState(documents);

  return (
    <div className="space-y-4">
      <SectionCard title="Documents & IDs">
        {docs.length === 0 ? (
          <p className="text-xs text-text-secondary">No documents uploaded</p>
        ) : (
          <div className="space-y-2">
            {docs.map((d, i) => (
              <div
                key={i}
                className="flex items-center gap-2 border-b border-surface-secondary pb-2 last:border-0"
              >
                <select
                  value={d.doc_type}
                  disabled={!canWrite}
                  onChange={(e) => {
                    const n = [...docs];
                    n[i] = { ...d, doc_type: e.target.value };
                    setDocs(n);
                  }}
                  className="rounded-btn border border-border-card bg-white px-2 py-1 text-xs text-near-black disabled:opacity-60"
                >
                  {DOC_TYPES.map((t) => (
                    <option key={t} value={t}>
                      {t}
                    </option>
                  ))}
                </select>
                <input
                  value={d.doc_name || ""}
                  readOnly={!canWrite}
                  onChange={(e) => {
                    const n = [...docs];
                    n[i] = { ...d, doc_name: e.target.value };
                    setDocs(n);
                  }}
                  placeholder="Document name / number"
                  className="flex-1 rounded-btn border border-border-card bg-white px-2 py-1 text-xs read-only:opacity-60"
                />
                <select
                  value={d.status || "pending"}
                  disabled={!canWrite}
                  onChange={(e) => {
                    const n = [...docs];
                    n[i] = { ...d, status: e.target.value };
                    setDocs(n);
                  }}
                  className="rounded-btn border border-border-card bg-white px-2 py-1 text-xs text-near-black disabled:opacity-60"
                >
                  <option value="pending">Pending</option>
                  <option value="submitted">Submitted</option>
                  <option value="verified">Verified</option>
                  <option value="expired">Expired</option>
                </select>
                {canWrite && (
                  <button
                    onClick={() => setDocs(docs.filter((_, j) => j !== i))}
                    className="text-xs text-error-text"
                  >
                    x
                  </button>
                )}
              </div>
            ))}
          </div>
        )}
        {canWrite && (
          <button
            type="button"
            onClick={() =>
              setDocs([
                ...docs,
                { doc_type: DOC_TYPES[0], doc_name: "", status: "pending" },
              ])
            }
            className="mt-2 text-xs font-medium text-rausch"
          >
            + Add document
          </button>
        )}
      </SectionCard>
      {canWrite && (
        <button
          onClick={() => onSave({ documents: docs })}
          disabled={saving}
          className="rounded-btn bg-near-black px-4 py-2 text-sm font-medium text-white hover:bg-rausch disabled:opacity-50"
        >
          {saving ? "Saving..." : "Save Documents"}
        </button>
      )}
    </div>
  );
}
